export default {
  training: {
    code: "Code",
    hours: "Stundenanzahl",
    hours_learning: "Unterrichtsstunden",
    public: "Vorgesehene Zielgruppe",
    comment: "Kommentar",
    registrants_number: "Anzahl der Angemeldeten",
    publish_success: "Referentiel erfolgreich veröffentlicht!",
    publish_program_success: "Programm erfolgreich veröffentlicht!",
    rncp: {
      nsf_codes: "NSF-Codes",
      form_codes: "Formacodes",
      rome_codes: "Rome-Codes",
      targeted_activities: "Angestrebte Tätigkeiten",
      domains: "Bereiche",
      industry_sector_and_types_job: "Wirtschaftssektor und Beschäftigungsarten",
      business_sectors: "Wirtschaftssektoren",
      types_of_jobs: "Beschäftigungsarten",
      due_date: "Ablaufdatum",
      previous_certification: "Frühere Zertifizierung",
      new_certification: "Neue Zertifizierung",
      editing_competency_framework: "Bearbeitung des Kompetenzrahmens",
      enable_critical_learnings: "Kritische Lerninhalte aktivieren",
      critical_learning_update_success: "Anzeigeeinstellung der kritischen Lerninhalte gespeichert",
      critical_learning_update_error: "Fehler beim Speichern der Einstellung",
      rncp_skills: "RNCP-Kompetenzen",
      missions: "zugeordnete Missionen",
      ai_suggestions: "KI-Vorschläge",
      skills_related: "Kompetenzen dieses Kompetenzblocks",
      missions_related: "Missionen dieses Kompetenzblocks",
      ai_suggestions_related_skills: "KI-Vorschläge – Ergänzende Kompetenzen",
      ai_suggestions_related_missions: "KI-Vorschläge – Ergänzende Missionen",
      relaunch_ai: "Neu starten (3 neue)",
      triad: "Heft,",
      badge: {
        rome: "ROME",
        rncp: "RNCP",
        triad: "Ausbildungsheft",
        job_offer: "Stellenangebote",
        offer: "Angebote",
        sources: "Quellen",
        triads: "Hefte",
        confidence: "Konfidenz",
      },
      workflow: {
        skill_import_label: "Kompetenzimport",
        enrichment_import_label: "KI-Anreicherung",
        publish_import_label: "Veröffentlichung",
        waiting_status_label: "Bevorstehend",
        pending_status_label: "In Bearbeitung",
        finished_status_label: "Abgeschlossen",
        import_button_label: "Importieren",
        enrichment_button_label: "Kompetenzen anreichern",
        publish_button_label: "Veröffentlichen",
        enrichment_progress_title: "Import läuft",
        enrichment_step_skills: "Import der Kompetenzen",
        enrichment_step_skills_description:
          "Analyse der vom Arbeitsmarkt erwarteten, im Referenzrahmen noch nicht erfassten Kompetenzen",
        enrichment_step_critical_learnings: "Import der kritischen Lerninhalte",
        enrichment_step_critical_learnings_description:
          "Begründete Vorschläge dazu, was ein Auszubildender auf jeder Kompetenzstufe können sollte",
        enrichment_step_missions: "Import der Aufträge",
        enrichment_step_missions_description:
          "Vorschlag von Aufgabentypen zum Kompetenzblock (Quellen: RNCP-Blatt, ROME-Referenzrahmen und Stellenangebote)",
        step_status_done: "abgeschlossen",
        step_status_pending: "läuft",
        step_status_error: "fehlgeschlagen",
        step_status_skipped: "nicht abgeschlossen",
        enrichment_failed_title: "Import fehlgeschlagen",
        enrichment_failed:
          "Ein Teil der KI-Analyse ist fehlgeschlagen. Erfolgreiche Teile bleiben angezeigt; Sie können die Analyse erneut starten.",
      },
      actions: {
        reimporting_skills: "Vorhandene Daten erkannt",
      },
      modal: {
        text: "Wie möchten Sie beim neuen Import vorgehen?",
        merge_button_title: "Zusammenführen",
        merge_button_text: "Vorhandene Daten behalten und nur neue hinzufügen",
        crush_button_title: "Ersetzen",
        crush_button_text: "Alle vorhandenen Daten löschen und durch neue ersetzen",
        alert_title: "Für diese Ausbildung existiert bereits eine Vorlage",
        alert_text: "Wie möchten Sie mit den neuen Daten vorgehen?",
        submit: "Import bestätigen",
      },
      alert: {
        empty_rncp_warning_text:
          "Um Daten importieren und Ihr erstes Kompetenzreferential erstellen zu können, müssen Sie einen RNCP-Titel " +
          "im Konfigurationsformular der Ausbildung angeben, das nur Administratoren zugänglich ist.",
        referential_publish_title: "Referential veröffentlichen",
        referential_publish_sub_title: "Sind Sie sicher, dass Sie dieses Referential veröffentlichen möchten?",
        error: "Etwas ist schiefgelaufen, bitte versuchen Sie es später erneut.",
        importing: "Daten werden importiert, bitte warten.",
        enriching: "Daten werden angereichert, bitte warten.",
        update_rncp: "Denken Sie daran, den RNCP-Code bei jeder neuen Veröffentlichung zu aktualisieren",
        rncp_sheet_import:
          "Bitte importieren Sie die Kompetenzen, um die Details des RNCP-Titels der Ausbildung anzuzeigen.",
        rncp_skill_import:
          "Bitte importieren Sie die Kompetenzen, um die Konfiguration des Ausbildungsreferentials zu beginnen.",
        due_date_in_month: "Ablauf in {month} Monaten",
        due_date_in_day: "Ablauf in {day} Tagen",
        empty_skills: "Derzeit keine Kompetenzen vorhanden",
        empty_missions: "Derzeit keine Missionen vorhanden",
        empty_suggestions: "Keine Vorschläge vorhanden. Bitte starten Sie die KI neu, um neue zu erhalten.",
        empty_block: "Derzeit kein Kompetenzblock vorhanden",
      },
      level: {
        niv3: "CAP/BEP (Niveau 3)",
        niv4: "BAC (Niveau 4)",
        niv5: "BAC+2 (Niveau 5)",
        niv7: "BAC+5 (Niveau 7)",
        niv8: "Doktorat (Niveau 8)",
      },
      source_detail: {
        criticality: {
          title: "Kritikalität",
          low: "Zu beobachten",
          medium: "Aufkommend",
          high: "Stark aufkommend",
        },
        pertinence: "Relevanzwert",
        criteria: {
          title: "4 ausgewählte Kriterien",
          pertinence_f: "Häufigkeit in Stellenangeboten",
          pertinence_a: "Semantische Ausrichtung",
          pertinence_p: "Branchennähe",
          pertinence_d: "Unterscheidungsmerkmal",
        },
        justification: "KI-Begründung",
        referential_presence: "Präsenz in Referenzsystemen",
        source: {
          rome: "ROME",
          esco: "ESCO",
          rncp: "RNCP",
          offres: "Stellenangebote",
          offre: "Stellenangebot",
          livret: "Heft",
          marche: "Markt",
        },
        source_offers: "Quellangebote",
        published_at: "Veröffentlicht am",
        view_offer: "Angebot anzeigen",
        present: "Vorhanden",
        absent: "Nicht vorhanden",
        offers_count: "{jobOfferCount} von {jobOfferTotal} analysierten Stellenangeboten erwähnen diese/s {type}.",
      },
    },
    program: {
      import_failed: "Der Import des Programms ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      model: "Vorlage",
      required: "Pfl./Opt.",
      ects: "ECTS",
      coefficient_short: "Koeff.",
      ai_confidence: "KI-Konfidenz",
      target_audience: "Zielgruppe",
      prerequisites: "Voraussetzungen",
      training_targets: "Ausbildungsziele",
      informations: "Praktische Informationen",
      general_informations: "Allgemeine Informationen",
      graduation: "Abschluss",
      route: "Weg",
      rncp_code: "RNCP-Code",
      graduation_type: "Abschlussart",
      total_volume: "Gesamtvolumen",
      ects_credits: "ECTS-Punkte",
      add_files: "Dateien ablegen",
      training_program: "Ausbildungsprogramm",
      duration: "Dauer",
      modality: "Modalität",
      pace: "Rhythmus",
      location: "Ort",
      professionalOutcomes: "Berufliche Perspektiven",
      extension_accepted_message: "Es werden nur PDF-, DOC-, DOCX-, XLS-, XLSX- und MSWORD-Dateien akzeptiert",
      steps: {
        import: {
          title: "Programmimport",
          button: "Importieren",
        },
        publish: {
          title: "Programmveröffentlichung",
          button: "Veröffentlichen",
        },
        incoming: "Bevorstehend",
        inprogress: "In Bearbeitung",
        finished: "Abgeschlossen",
      },
      actions: {
        reimporting_program: "Programm erneut importieren?",
      },
      modal: {
        text: "Für diese Ausbildung existiert bereits ein Programm. Wie möchten Sie vorgehen?",
        merge_button_title: "Behalten und ergänzen",
        merge_button_text: "Vorhandene Daten werden behalten, neue werden hinzugefügt.",
        crush_button_title: "Vollständig ersetzen",
        crush_button_text: "Alle vorhandenen Daten werden gelöscht und ersetzt.",
        alert_title: "Wichtig",
        alert_text: "Diese Aktion wirkt sich auf künftig veröffentlichte Programme und zugehörige Ausbildungen aus.",
        submit: "Import bestätigen",
        "general-info": "Allgemeine Informationen bearbeiten",
        "target-audience": "Zielgruppe und Voraussetzungen bearbeiten",
        objectives: "Ausbildungsziele bearbeiten",
        "practical-info": "Praktische Informationen bearbeiten",
      },
      training_period: {
        heading: {
          code: "Code",
          label: "Bezeichnung",
          type: "Typ",
          required: "Pfl./Opt.",
          hours: "Stunden",
          ects: "ECTS",
          coef: "Koeff.",
          actions: "Aktionen",
        },
      },
      alert: {
        importing: "Daten werden importiert, bitte warten.",
        empty_semester:
          "Derzeit kein Semester vorhanden. Bitte fügen Sie eines\n" +
          "                  manuell durch Klick auf die Schaltfläche + hinzu",
        empty_unit:
          "Derzeit keine Einheiten und Module vorhanden. Bitte fügen Sie\n" +
          "                  manuell durch Klick auf die Schaltflächen + hinzu",
        program_import: "Bitte importieren Sie das Programm, um die Konfiguration der Vorlage zu beginnen",
        file_uploaded_success: "Datei erfolgreich importiert | {count} Dateien erfolgreich importiert",
        file_upload_error: "Fehler beim Importieren der Dateien",
        note: "Hinweis",
        note_text:
          "Diese Informationen wurden automatisch aus der PDF-Vorlage extrahiert. Sie können sie durch Klick auf das Bleistiftsymbol ändern.",
        warning_points: "Hinweise",
        warning_points_text: "3 Module ohne Code • 2 Module müssen überprüft werden",
        empty_general_informations: "Bitte importieren Sie das Programm, um die allgemeinen Informationen anzuzeigen",
        program_publish_title: "Ausbildungsprogramm veröffentlichen",
        program_publish_sub_title:
          "Sind Sie sicher, dass Sie dieses Ausbildungsprogramm für alle Jahrgänge veröffentlichen möchten?",
        unit_missing_code: ({ plural, named }) =>
          plural([`${named("count")} Einheit ohne Code`, `${named("count")} Einheiten ohne Code`]),
        subject_missing_code: ({ plural, named }) =>
          plural([`${named("count")} Modul ohne Code`, `${named("count")} Module ohne Code`]),
        unit_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} Einheit muss überprüft werden`,
            `${named("count")} Einheiten müssen überprüft werden`,
          ]),
        subject_need_validation: ({ plural, named }) =>
          plural([`${named("count")} Modul muss überprüft werden`, `${named("count")} Module müssen überprüft werden`]),
        verification: "Zu prüfende Daten",
        low_confidence_score:
          "Die KI hat dieses Modul mit einer Konfidenz von {confidence} % erkannt. Bitte überprüfen und korrigieren Sie die folgenden Informationen vor der Bestätigung.",
      },
    },
    matrix: {
      title: "UE / Kompetenz-Matrix",
      enrich: "Anreicherung neu starten",
      enriching: "Die Matrix wird derzeit durch die KI angereichert, bitte warten.",
      header: {
        title: "Kompetenzen",
        block: ({ plural }) => plural(["Block", "Blöcke"]),
        skill: ({ plural }) => plural(["Kompetenz ", "Kompetenzen"]),
      },
      tooltip: {
        total: "Vollständige Entsprechung",
        secondary: "Sekundäre Entsprechung",
        ai: "KI-Vorschlag – {confidence} % Konfidenz",
      },
      tutorial: {
        title: "Benutzerhandbuch der Matrix",
        line_1_with_ai:
          "<strong>Klicken Sie auf eine Zelle</strong>, um ihren Zustand zu ändern: KI-Vorschlag → Vollständig → Sekundär → Keine → Vollständig",
        line_1_without_ai:
          "<strong>Klicken Sie auf eine Zelle</strong>, um ihren Zustand zu ändern: Vollständig → Sekundär → Keine → Vollständig",
        line_2: "<strong>KI-Vorschläge aktivieren/deaktivieren</strong> mit der Schaltfläche oben links",
        line_3: "<strong>Blöcke und UE aufklappen</strong>, um Details zu Kompetenzen und Modulen ein-/auszublenden",
        line_4: "<strong>Hellgrüne Zellen</strong> zeigen eine indirekte Verbindung auf der unteren Ebene an",
        line_5: "<strong>Orangefarbene ⚠-Abzeichen</strong> markieren Blöcke/Kompetenzen ohne Entsprechung",
        line_6: "<strong>Geänderte Entsprechungen werden automatisch gespeichert",
      },
      legend: {
        title: "Legende",
        total: "Vollständige Entsprechung",
        secondary: "Sekundäre Entsprechung",
        ai: "KI-Vorschlag (zu validieren)",
      },
      suggestion: ({ plural }) => plural(["Vorschlag", "Vorschläge"]),
      mappings: ({ plural }) => plural(["Entsprechung", "Entsprechungen"]),
      mapping: {
        success: "Entsprechung erfolgreich aktualisiert!",
        removed: "Entsprechung erfolgreich gelöscht!",
        add: "Entsprechung erfolgreich hinzugefügt!",
      },
    },
    contact: {
      detail: {
        title: ({ named }) => `Details des Kontakts ${named("name")}`,
      },
    },
    contract_list: "Vertragsliste",
    contacts: {
      success: "Kontakte erfolgreich gespeichert!",
    },
    plan_contract: {
      baseline: 'Um das Jahr auszuwählen, an dem Sie arbeiten, klicken Sie auf "Aktivieren"',
    },
    stats: {
      tab_title: "Statistiken",
      export_all_excel: "Alles exportieren (Excel)",
      export_all_csv: "Alles exportieren (CSV)",
      export_csv: "Als CSV exportieren",
      empty: "Keine Statistiken für diese Ausbildung verfügbar.",
      calculation_note:
        "<strong>Berechnung der Statistiken</strong>: Raten berechnet auf veröffentlichten und nicht archivierten Fragebögen." +
        " Ein Trio ist vollständig, wenn die 3 Profile (Auszubildender, Tutor, pädagogischer Verantwortlicher) Zugang zum Heft haben." +
        " Daten werden jede Nacht aktualisiert.",
      table: {
        promotion: "Jahrgang",
        questionnaires: "Fragebögen",
        skills: "Kompetenzen",
        connections: "Verbindungen",
        triads: "Trios",
        export: "Export",
      },
      profiles: {
        apprentice: "Auszubildender",
        tutor: "Tutor",
        apprentice_master: "Ausbildungsmeister",
      },
      indicators: {
        questionnaire_fill_rate: "Ausfüllrate der Fragebögen",
        skill_fill_rate: "Ausfüllrate der Kompetenzen",
        user_connection_rate: "Verbindungsrate der Benutzer",
        completed_triads_rate: "Rate der vollständigen Trios",
      },
      subcounts: {
        promotions: "Jahrgang/Jahrgänge",
        active_users: "aktive Benutzer",
        triads: "Trio(s)",
      },
    },
    space: "Bereich",
    go_to: {
      registration: "Voranmeldeformular",
      contract: "Vertragsblatt",
    },
    sheet: "Blatt",
    dashboard: "Dashboard",
    company_contact: "Unternehmenskontakte",
  },
  employee: ({ plural }) => plural(["Mitarbeiter/in", "Mitarbeiter"]),
};
